import { isUndefined } from 'lodash';
import { Me } from '../../../../../generated';
import type { TypePolicies } from '../../../../../utils/types/TypePolicies';
import TEXT from './generated/TEXT/GraphqlClient_AccountUserTypePolicy';

TEXT.DEFINE({
  /** User status: pending */
  pending: 'Pending',
  /** User status: active */
  active: 'Active',
  /** User status: inactive */
  inactive: 'Inactive',
  /** Account user type: admin */
  labelAdmin: 'Content Admin',
  /** Account user type: guest */
  labelGuest: 'Guest',
  /** Account user type: member */
  labelMember: 'Member',
  /** Account user type: owner */
  labelOwner: 'Owner',
  /** Account user type: reviewer */
  labelReviewer: 'Reviewer',
});

export const typePolicies: TypePolicies = {
  AccountUser: {
    fields: {
      isCurrentUser: {
        read: (existing, { readField, cache }) => {
          if (!isUndefined(existing)) {
            return existing;
          }

          const userId = readField('userId');
          const currentUser = cache.readQuery({ query: Me });

          return currentUser?.me?.id === userId;
        },
      },
      displayAccountUserType: {
        read: (__existing, { readField }) => {
          const userType = readField<string>('accountUserType');
          const licenseType = readField<string>('licenseType');

          if (licenseType === 'GUEST') {
            return TEXT.labelGuest;
          }

          if (licenseType === 'REVIEWER') {
            return TEXT.labelReviewer;
          }

          if (userType === 'ADMIN') {
            return TEXT.labelAdmin;
          }

          if (userType === 'OWNER') {
            return TEXT.labelOwner;
          }

          return TEXT.labelMember;
        },
      },
      displayName: {
        read: (existing, { readField }) => {
          const inviteEmailAddress = readField<string>('inviteEmailAddress');
          const name = readField<string>('name');
          const email = readField<string>('email');

          return existing || name || email || inviteEmailAddress;
        },
      },
      email: (email, { readField }) =>
        email || readField<string>('inviteEmailAddress'),
      displayStatus: {
        read: (__existing, { readField }) => {
          const status = readField<string>('status');

          if (status === 'ACTIVE') {
            return TEXT.active;
          }

          if (status === 'INACTIVE') {
            return TEXT.inactive;
          }

          return TEXT.pending;
        },
      },
    },
  },
};
